import { useState, useEffect, useContext } from "react";
import { Link, useLocation } from "react-router-dom";
import { Empty } from "antd";

import { Card } from "@mui/material";
import Grid from "@mui/material/Grid";
import Pagination from "@mui/material/Pagination";
import Tooltip from "@mui/material/Tooltip";

import SuiBox from "components/SuiBox";
import SuiTypography from "components/SuiTypography";
import SuiSelect from "components/SuiSelect";
import SuiInput from "components/SuiInput";
import SuiButton from "components/SuiButton";
import SuiAvatar from "components/SuiAvatar";
import SuiBadge from "components/SuiBadge";
import SuiBadgeDot from "components/SuiBadgeDot";

import NumberFormat from "react-number-format";

import toast from "react-hot-toast";
import moment from "moment";
import { capitalCase } from "capital-case";

import { AccountContext } from "context/account";

import Prompt from "components/UpStyled/Prompt";
import api from "services/api";
import qs from "query-string";

import { getStyleImages, matchYoutubeUrl } from "utils/imageHelper";
import { filterParser, formatAddress } from "utils/helper";

import ProjectCard from "components/UpStyled/project-card/ProjectCard";
import StyleCard2 from "components/UpStyled/StyleCard2";
import ManufacturerCard2 from "./components/ManufacturerCard2";

import ma_default_img from "assets/images/upstyled/default_background.png";
import PostDetailModal from "pages/de/posts/detail";
import PostCard from "pages/de/posts/components/PostCard";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";

const SearchResultPage = () => {
  const [data, setData] = useState({ hits: [], nbHits: 0, estimatedTotalHits: 0 });

  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState(10);
  const [detailVisible, setDetailVisible] = useState(false);
  const [selectedPost, setSelectedPost] = useState();

  const account = useContext(AccountContext);
  const location = useLocation();
  const url = location.href ? location.href : location.pathname + location.search;
  const urlObj = qs.parseUrl(url);
  const keyword = urlObj?.query?.keyword;
  const searchType = urlObj?.query?.type;

  useEffect(() => {
    if (account.id) {
      const offset = 0;
      const limit = pageSize;
      setPage(1);

      handleSearchResult(offset, limit, keyword, searchType);
    }
  }, [account.id, keyword, searchType]);

  const handleSearchResult = (offset, limit, keyword, searchType) => {
    if (searchType == "style") {
      retrieveStyles(offset, limit, keyword);
    } else if (searchType == "collection") {
    } else if (searchType == "project") {
      retrieveProjects(offset, limit, keyword);
    } else if (searchType == "manufacturer") {
      retrieveManufacturers(offset, limit, keyword);
    } else if (searchType == "post") {
      retrievePosts(offset, limit, keyword);
    } else {
      toast.error("Unknown search type");
    }
  };
  //================================================================
  //retrive search result data
  //================================================================
  const retrieveStyles = async (offset = 0, limit = pageSize, q = "") => {
    const payload = { offset, limit, sort: ["updated_at:desc"] };
    if (q) {
      payload["q"] = q;
    }
    try {
      const { data } = await api.products.searchStyles(payload);
      setData(data ? data : { hits: [], nbHits: 0 });
    } catch (err) {
      console.log(err);
    }
  };

  const retrieveProjects = async (offset = 0, limit = pageSize, q = "") => {
    const payload = { offset, limit, sort: ["status:desc", "updated_at:desc"] };
    if (q) {
      payload["q"] = q;
    }
    let myFilter = {};
    if (account.account_type == "ma") {
      myFilter = { status: { neq: "requested" } };
    }
    const newFilterStr = filterParser(myFilter);
    if (newFilterStr) {
      payload["filter"] = newFilterStr;
    }

    try {
      const { data } = await api.project.search(payload);
      setData(data ? data : { hits: [], nbHits: 0 });
    } catch (err) {
      console.log(err);
    }
  };

  const retrieveManufacturers = async (offset = 0, limit = pageSize, q = "") => {
    // const { data } = await api.manufacturer.list({ offset, limit: pageSize });
    const payload = { offset, limit, sort: ["account_status:asc", "profile_update_level:desc"] };
    if (q) {
      payload["q"] = q;
    }
    let myFilter = { account_type: "ma" };

    const newFilterStr = filterParser(myFilter);
    if (newFilterStr) {
      payload["filter"] = newFilterStr;
    }
    const { data } = await api.users.search(payload);
    setData(data ? data : { hits: [], nbHits: 0 });
  };

  const retrievePosts = async (offset = 0, limit = pageSize, q = "") => {
    const payload = { offset, limit };
    if (q) {
      payload["q"] = q;
    }

    //get sorting options from form values

    try {
      const { data } = await api.post.searchPosts(payload);
      setData(data ? data : { hits: [], nbHits: 0 });
    } catch (err) {
      console.log(err);
    }
  };
  //----------------------------------------------------------------

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    const offset = pageSize * (newPage - 1);
    const limit = pageSize;
    handleSearchResult(offset, limit, keyword, searchType);
  };

  const handleChangeRowsPerPage = (option) => {
    const newPageSize = parseInt(option.value, 10);
    setPageSize(newPageSize);
    setPage(1);
    const offset = 0;
    const limit = newPageSize;
    handleSearchResult(offset, limit, keyword, searchType);
  };

  const totalNumber = data.nbHits ? data.nbHits : data.estimatedTotalHits;
  const pageCount = parseInt(Math.ceil(totalNumber / pageSize), 10);
  const pageOptions = [];
  for (let i = 0; i < pageCount; i++) {
    pageOptions.push(i);
  }
  let entriesStart = pageSize * (page - 1) + 1;
  const entriesEnd = pageSize * page > totalNumber ? totalNumber : pageSize * page;
  if (entriesStart > entriesEnd) {
    entriesStart = entriesEnd;
  }

  const renderSearchResult = (data) => {
    if (searchType == "style") {
      return (
        <SuiBox display="flex" justifyContent="flex-start" sx={{ flexWrap: "wrap" }} gap={2}>
          {data.map((x) => (
            <StyleCard2 product={x} size="md" detailUrl={`/workspace/styles-master?id=${x.id}`} />
          ))}
        </SuiBox>
      );
    } else if (searchType == "project") {
      return (
        <Grid container spacing={2}>
          {data.map((x, index) => (
            <Grid item xs={12} sm={12} md={12} lg={6}>
              {" "}
              <ProjectCard
                key={index}
                detailUrl={`/produce/all-projects?id=${x.id}`}
                project={x}
                chats={null}
                actions={null}
              />{" "}
            </Grid>
          ))}
        </Grid>
      );
    } else if (searchType == "manufacturer") {
      return (
        <Grid container spacing={2}>
          {data.map((u, index) => {
            const store = u?.stores && u.stores.length > 0 ? u.stores[0] : {};
            const serviceStages = store?.metadata?.services_offered
              ? Object.keys(store.metadata.services_offered)
              : [];
            let image = "";
            const gallery = store?.gallery || [];
            for (let i = 0; i < gallery.length; i++) {
              //find first available image on  gallery

              if (
                gallery[i].startsWith("blob") ||
                matchYoutubeUrl(gallery[i]) ||
                gallery[i].endsWith(".mp4")
              ) {
              } else {
                image = gallery[i];
                break;
              }
            }

            if (!image) {
              //trying to use background image
              image = store?.metadata?.background_image;
            }

            if (!image) {
              //using default image
              image = ma_default_img;
            }

            return (
              <Grid item xs={12} sm={6} md={6} lg={4} xl={3}>
                <ManufacturerCard2
                  selectable={false}
                  image={image}
                  title={store?.name}
                  description={store?.detail}
                  story={store?.story}
                  address={formatAddress(store?.metadata?.address, true)}
                  rating={store?.rating}
                  services={serviceStages}
                  account_status={u?.account_status}
                  action={{
                    route: `/wall/portfolio/${u.id}`,
                    color: "info",
                    label: "view profile",
                  }}
                />
              </Grid>
            );
          })}
        </Grid>
      );
    } else if (searchType == "post") {
      return (
        <SuiBox sx={{ width: "100%", height: "100%" }}>
          <ResponsiveMasonry columnsCountBreakPoints={{ 250: 1, 650: 2, 1050: 3, 1400: 4 }}>
            <Masonry>
              {data?.map((p, index) => (
                <div
                  className="mx-2 my-2"
                  style={{
                    overflow: "hidden",
                  }}
                >
                  <PostCard
                    index={index}
                    post={p}
                    sx={{ height: "auto", width: "100%" }}
                    handleClick={() => {
                      setDetailVisible(true);
                      setSelectedPost(p);
                    }}
                  />
                </div>
              ))}
            </Masonry>
          </ResponsiveMasonry>
        </SuiBox>
      );
    } else {
      return <div />;
    }
  };

  return (
    <SuiBox>
      <SuiBox pb={3}>
        <SuiBox>
          <SuiBox
            display="flex"
            justifyContent="flex-start"
            alignItems="flex-end"
            gap={1}
            sx={{ ml: 2 }}
          >
            <SuiTypography variant="h5" textTransform="capitalize">
              Search Result
            </SuiTypography>
          </SuiBox>
        </SuiBox>
        <Card sx={{ p: 3 }}>
          <SuiBox display="flex" justifyContent="flex-start" sx={{ flexWrap: "wrap" }} gap={2}>
            {data?.hits && data.hits.length > 0 ? (
              renderSearchResult(data.hits || [])
            ) : (
              <SuiBox sx={{ width: "100%", my: 4 }}>
                <Empty
                  description={
                    <SuiTypography variant="h6" color="secondary" fontWeight="regular">
                      No matches found!
                    </SuiTypography>
                  }
                />
              </SuiBox>
            )}
          </SuiBox>
        </Card>
        <SuiBox
          display="flex"
          flexDirection={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          p={3}
        >
          <div className="flex items-center">
            <SuiBox mb={{ xs: 3, sm: 0 }}>
              <SuiTypography variant="button" color="secondary" fontWeight="regular">
                Showing {entriesStart} to {entriesEnd} of {totalNumber} entries
              </SuiTypography>
            </SuiBox>

            <SuiBox display="flex" alignItems="center" gap={1}>
              <SuiSelect
                defaultValue={{ value: pageSize, label: pageSize }}
                options={[10, 20, 50].map((entry) => ({ value: entry, label: entry }))}
                onChange={handleChangeRowsPerPage}
                size="small"
              />

              <SuiTypography variant="caption" color="secondary">
                entries per page
              </SuiTypography>
            </SuiBox>
          </div>
          <Pagination
            variant={"outlined"}
            color={"info"}
            count={pageOptions.length}
            defaultPage={page}
            page={page}
            onChange={handleChangePage}
          />
        </SuiBox>
        {detailVisible && selectedPost ? (
          <PostDetailModal
            handleClose={(postDetail) => {
              const newPostList = { ...data };
              for (let i = 0; i < newPostList.hits.length; i++) {
                if (newPostList.hits[i].id == selectedPost.id) {
                  newPostList.hits[i] = postDetail;
                }
              }
              setData(newPostList);
              setDetailVisible(false);
            }}
            visible={detailVisible}
            post={selectedPost}
          />
        ) : null}
      </SuiBox>
    </SuiBox>
  );
};

export default SearchResultPage;
